import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess, exhibitionActionId } from "../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import Pagination from "../../../../utils/pagination";
import { fill_action } from '../../../../actions/fillCombo_action';
import { insertB2B_TimeSlot_action, getB2B_TimeSlot_action, deleteB2B_TimeSlot_action } from '../../../../actions/admin_module_action/delegate_master_action/delegate_B2BTimeSlot_action';
import $ from 'jquery'
class Delegate_B2B_TimeSlot extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            currentPage: 1,
            ExihibitionID: '',
            B2B_TimeSlotList: [],
            DescriptionList: [],
            tempDescriptionList: [],
            NoteTypeList: [],
            exhibitionList: [],
            ExhibitionID: '',
            IsDuplicatePresent: false,
            isOpen: false,
            deleteB2BTimeSlotID: '',
            deleteRowID: '',
        }
        this.updateItem = this.updateItem.bind(this)
    }

    componentDidMount() {
        this.getFillList(exhibitionActionId, '', '', '', '')
        this.loadscript()
    }

    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }
    getFillList(value, userID, keyword, keyvalue) {
        this.setState({ isLoading: true })
        this.props
            .fill_action(value, (userID == '' || userID == null) ? null : userID, keyword != '' ? keyword : null, keyvalue != '' ? keyvalue : null)
            .then((data) => {
                if (data.error != 1) {
                    if (value == exhibitionActionId) {
                        this.setState({
                            exhibitionList: data.data,
                        })
                    }
                    this.setState({ isLoading: false })
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    duplicatesCheckedValue = (data, keys) => {
        const hasDuplicates = Object.values(
            data.reduce((acc, obj) => {
                const combinedKey = keys.map(key => obj[key]).join('|');
                acc[combinedKey] = (acc[combinedKey] || 0) + 1;
                return acc;
            }, {})
        ).some(value => value > 1);

        if (hasDuplicates) {
            this.setState({ IsDuplicatePresent: true })
        } else {
            this.setState({ IsDuplicatePresent: false })
        }

        return hasDuplicates;
    };


    updateItem(item) {
        this.setState({ currentPage: item });
    }

    getB2B_TimeSlotDetails() {
        const { ExhibitionID } = this.state
        this.setState({ isLoading: true })
        this.props.getB2B_TimeSlot_action(ExhibitionID)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != '') {
                        data.data.map((item, i) => {
                            item.id = i + 1
                            item.B2BDate = new Date(item.B2BDate)
                            item.B2BStartTime = moment.utc(item.B2BStartTime).format('HH:mm')
                            item.B2BEndTime = moment.utc(item.B2BEndTime).format('HH:mm')
                        })
                        this.setState({ B2B_TimeSlotList: data.data })
                    } else {
                        this.setState({ B2B_TimeSlotList: [{ id: 1, B2BTimeSlotID: '', ExhibitionID: '', B2BDate: '', B2BStartTime: '', B2BEndTime: '', B2BLocation: '' }] })
                    }
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    insertUpdateB2B_TimeSlotDetails() {
        const { B2B_TimeSlotList, ExhibitionID } = this.state
        this.setState({ isLoading: true })
        const exceptKeys = ['B2BDate', 'B2BStartTime', 'B2BEndTime', 'B2BLocation']
        const validation = this.areAllParamsNotBlankExcept(B2B_TimeSlotList, exceptKeys)
        B2B_TimeSlotList.map(item => {
            item.ExhibitionID = ExhibitionID
        })
        const validationforDuplicate = this.duplicatesCheckedValue(B2B_TimeSlotList, ['B2BDate', 'B2BStartTime', 'B2BEndTime', 'B2BLocation'])
        if (validation) {
            if (!validationforDuplicate) {
                this.props.insertB2B_TimeSlot_action(B2B_TimeSlotList)
                    .then((data) => {
                        if (data.error != 1) {
                            this.getB2B_TimeSlotDetails()
                            toastSuccess("data updated Successfully!")
                            this.setState({ isLoading: false })
                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                this.setState({ isLoading: false })
                toastError("Duplicate Date, Timeslot AND Location are not allowed!")
            }
        } else {
            this.setState({ isLoading: false })
            toastError("Please Enter all feilds!")
        }
    }

    areAllParamsNotBlankExcept(arr, exceptKeys) {
        return arr.every(obj => {
            return Object.keys(obj).every(key => {
                console.log("obj[key]----->", obj[key])
                return !exceptKeys.includes(key) || (obj[key] !== null && obj[key] !== undefined && obj[key] !== '');
            });
        });
    }

    deleteB2B_TimeSlotDetails(id) {
        // this.setState({ isLoading: true })
        this.props.deleteB2B_TimeSlot_action(id)
            .then((data) => {
                if (data.error != 1) {
                    this.getB2B_TimeSlotDetails()
                    // this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    addB2B_TimeSlotList(i) {
        const { B2B_TimeSlotList } = this.state
        B2B_TimeSlotList.splice(
            i + 1, 0, {
            id: B2B_TimeSlotList.length + 1,
            B2BTimeSlotID: '',
            ExhibitionID: '',
            B2BDate: '',
            B2BStartTime: '',
            B2BEndTime: '',
            B2BLocation: ''
        }
        )
        this.setState({ B2B_TimeSlotList: B2B_TimeSlotList })
    }

    deleteB2B_TimeSlotList() {
        const { deleteB2BTimeSlotID, deleteRowID } = this.state
        if (deleteB2BTimeSlotID != '') {
            this.deleteB2B_TimeSlotDetails(deleteB2BTimeSlotID)
        } else {
            this.setState({ isLoading: true })
            const { B2B_TimeSlotList } = this.state
            const filterArray = B2B_TimeSlotList.filter(item => item.id != deleteRowID)
            filterArray.map((item, i) => {
                item.id = i + 1
            })
            this.setState({ B2B_TimeSlotList: filterArray }, () => {
                this.setState({ isLoading: false })
            })
        }
        this.setState({ IsDuplicatePresent: false, isOpen: false })
    }

    onB2B_TimeSlotInput(event, i, value) {
        const { B2B_TimeSlotList } = this.state
        B2B_TimeSlotList.map((data, index) => {
            if (i == index) {
                console.log("event-->", event)
                console.log("value-->", value)
                if (value == 'ExhibitionID') {
                    data.ExhibitionID = event
                } else if (value == 'B2BDate') {
                    data.B2BDate = event
                } else if (value == 'B2BStartTime') {
                    data.B2BStartTime = event
                } else if (value == 'B2BEndTime') {
                    if (event >= data.B2BStartTime) {
                        data.B2BEndTime = event
                    } else {
                        toastError("To time is greater than equal to From time")
                        data.B2BEndTime = ''
                    }
                } else if (value == 'B2BLocation') {
                    data.B2BLocation = event
                }
                if (data.ItineraryDate != '' && data.StartTime != '' && data.EndTime != '' && data.B2BLocation != '') {
                    const validation = this.duplicatesCheckedValue(B2B_TimeSlotList, ['B2BDate', 'B2BStartTime', 'B2BEndTime', 'B2BLocation'])
                    console.log("validation---------->", validation)
                    if (validation) {
                        toastError("Duplicate Date, Timeslot AND Location are not allowed!")
                    } else {
                        this.setState({})
                    }
                }
            }
        })
        this.setState({ B2B_TimeSlotList: B2B_TimeSlotList })
    }

    popOpen(id, B2BTimeSlotID) {
        this.setState({ isOpen: true })
        if (B2BTimeSlotID != '') {
            this.setState({
                deleteB2BTimeSlotID: B2BTimeSlotID,
                deleteRowID: '',
            })
        } else {
            this.setState({
                deleteB2BTimeSlotID: '',
                deleteRowID: id,
            })
        }
    }

    record(B2B_TimeSlotList) {
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr style={{ border: '1px solid #ccc' }}>
                        <th className="text-center" style={{ width: '150px' }}>B2B Date<span className="text-red">*</span></th>
                        <th className="text-center" style={{}}>From Time<span className="text-red">*</span></th>
                        <th className="text-center" style={{}}>To Time<span className="text-red">*</span></th>
                        <th className="text-center" style={{}}>Location<span className="text-red">*</span></th>
                        <th className="text-center" style={{}}>Action<span className="text-red">*</span></th>
                    </tr>
                </thead>
                <tbody style={{ overflow: 'auto' }}>
                    {
                        B2B_TimeSlotList != '' && B2B_TimeSlotList != null ? (
                            B2B_TimeSlotList.map((data, i) => (
                                <tr key={i}>
                                    <td className="p-0">
                                        <DatePicker selected={data.B2BDate}
                                            onChange={(date) => this.onB2B_TimeSlotInput(new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), i, 'B2BDate')}
                                            dateFormat={"dd/MM/yyyy"} className="form-control rounded-0 px-2"
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            placeholderText="DD/MM/YYYY"
                                            dayClassName={() => "example-datepicker-day-class"}
                                            popperClassName="example-datepicker-class" />
                                    </td>
                                    <td className="p-0">
                                        <input
                                            type="time"
                                            className="form-control rounded-0 px-2"
                                            value={data.B2BStartTime}
                                            onChange={(e) => this.onB2B_TimeSlotInput(e.target.value, i, 'B2BStartTime')}
                                        />
                                    </td>
                                    <td className="p-0">
                                        <input
                                            type="time"
                                            disabled={data.B2BStartTime == ''}
                                            className="form-control rounded-0 px-2"
                                            value={data.B2BEndTime}
                                            onChange={(e) => this.onB2B_TimeSlotInput(e.target.value, i, 'B2BEndTime')}
                                        />
                                    </td>
                                    <td className="p-0">
                                        <input className="form-control rounded-0 px-2"
                                            type="text"
                                            value={data.B2BLocation}
                                            maxLength={100}
                                            onChange={(e) => this.onB2B_TimeSlotInput(e.target.value, i, 'B2BLocation')}
                                        />
                                    </td>
                                    <td className="text-center p-0">
                                        <button
                                            title="Add Note"
                                            class="btn btn-sm padding_0"
                                            onClick={() => this.addB2B_TimeSlotList(i)}
                                        >
                                            <i class="fa fa-plus action_btn_table"></i>
                                        </button>
                                        {this.state.B2B_TimeSlotList.length != 1 &&
                                            <button
                                                title="Delete Note"
                                                class="btn btn-sm padding_0"
                                                onClick={() => this.popOpen(data.id, data.B2BTimeSlotID)}
                                            >
                                                <i class="fa fa-trash action_btn_table"></i>
                                            </button>
                                        }
                                    </td>
                                </tr>
                            ))
                        ) : (<tr><td colSpan={6} className='text-center'>Record not found</td></tr>)
                    }
                </tbody>
            </table>)
    }


    render() {
        const { isLoading, B2B_TimeSlotList, currentPage, ExhibitionID, isOpen } = this.state

        const recordsPerPage = 10
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        // Records to be displayed on the current page
        const currentRecords = B2B_TimeSlotList.slice(indexOfFirstRecord, indexOfLastRecord)
        const nPages = Math.ceil(B2B_TimeSlotList.length / recordsPerPage)

        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height" style={{ marginTop: '5rem' }}>
                        <AdminDrawer />
                        <div className="row" style={{ marginLeft: '0.2rem' }}>
                            <div className="step-name">
                                <p>B2B TimeSlot</p>
                            </div>
                        </div>
                        <div className="row" style={{ margin: 'auto' }}>
                            <div class="col-md-3 mt-2">
                                <label>Exhibition Name</label>
                                <select className="form-control"
                                    value={ExhibitionID}
                                    onChange={(e) => this.setState({ ExhibitionID: e.target.value, B2B_TimeSlotList: '' }, () => e.target.value != '' && this.getB2B_TimeSlotDetails())}
                                >
                                    <option value={''}>Select</option>
                                    {
                                        this.state.exhibitionList.length > 0 && this.state.exhibitionList.map((data) => (
                                            <option key={data.ExhibitionID} value={data.ExhibitionID}>{data.ExhibitionName}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="row" style={{ margin: 'auto', width: '98%' }}>
                            <div className="asc" style={{ padding: '10px 0' }}>
                                {B2B_TimeSlotList != '' && <div class="">
                                    <button type="button" class="btn btn-primary rounded-0 my-2" style={{ float: 'right' }}
                                        onClick={() => this.insertUpdateB2B_TimeSlotDetails()}>
                                        Save
                                    </button>
                                </div>}
                                <div className="table-responsive" style={{ height: '65vh' }}>
                                    {this.record(B2B_TimeSlotList)}
                                </div>

                            </div>

                        </div>
                    </div>

                </>

                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title modal_title_text text-danger">Confirm Clear</h5>
                                <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="pop_label">Do you really want to delete this record ?</p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua"
                                        onClick={(e) => this.deleteB2B_TimeSlotList(e)}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpen: false })}>No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
            </>
        );
    }
}

export default withRouter(connect(null, { fill_action, insertB2B_TimeSlot_action, getB2B_TimeSlot_action, deleteB2B_TimeSlot_action })(Delegate_B2B_TimeSlot));